import * as Types from '../../../../generated/types';

import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type TemplateDetailsForTemplateTreeItemFragment = { __typename: 'Template', id: string, legacyId: number, type: Types.TemplateType, organization: { __typename: 'Organization', id: string }, revisions: Array<{ __typename: 'TemplateRevision', id: string, legacyId: number }>, latestRevision?: { __typename: 'TemplateRevision', id: string, legacyId: number } | null };

export type GetTemplateDetailsForTemplateTreeItemQueryVariables = Types.Exact<{
  legacyId: Types.Scalars['Int']['input'];
}>;


export type GetTemplateDetailsForTemplateTreeItemQuery = { __typename: 'Query', template: { __typename: 'Template', id: string, legacyId: number, type: Types.TemplateType, organization: { __typename: 'Organization', id: string }, revisions: Array<{ __typename: 'TemplateRevision', id: string, legacyId: number }>, latestRevision?: { __typename: 'TemplateRevision', id: string, legacyId: number } | null } };

export type MaterialDetailsForTemplateTreeItemFragment = { __typename: 'Material', id: string, legacyId: number, revisions: Array<{ __typename: 'MaterialRevision', id: string, legacyId: number }>, latestCyclesRevision?: { __typename: 'MaterialRevision', id: string, legacyId: number } | null };

export type GetMaterialDetailsForTemplateTreeItemQueryVariables = Types.Exact<{
  legacyId: Types.Scalars['Int']['input'];
}>;


export type GetMaterialDetailsForTemplateTreeItemQuery = { __typename: 'Query', material: { __typename: 'Material', id: string, legacyId: number, revisions: Array<{ __typename: 'MaterialRevision', id: string, legacyId: number }>, latestCyclesRevision?: { __typename: 'MaterialRevision', id: string, legacyId: number } | null } };

export type CreateTemplateRevisionForTemplateTreeItemMutationVariables = Types.Exact<{
  input: Types.MutationCreateTemplateRevisionInput;
}>;


export type CreateTemplateRevisionForTemplateTreeItemMutation = { __typename: 'Mutation', createTemplateRevision: { __typename: 'TemplateRevision', id: string, legacyId: number } };

export const TemplateDetailsForTemplateTreeItemFragmentDoc = gql`
    fragment TemplateDetailsForTemplateTreeItem on Template {
  id
  legacyId
  type
  organization {
    id
  }
  revisions {
    id
    legacyId
  }
  latestRevision {
    id
    legacyId
  }
}
    `;
export const MaterialDetailsForTemplateTreeItemFragmentDoc = gql`
    fragment MaterialDetailsForTemplateTreeItem on Material {
  id
  legacyId
  revisions {
    id
    legacyId
  }
  latestCyclesRevision {
    id
    legacyId
  }
}
    `;
export const GetTemplateDetailsForTemplateTreeItemDocument = gql`
    query getTemplateDetailsForTemplateTreeItem($legacyId: Int!) {
  template(legacyId: $legacyId) {
    ...TemplateDetailsForTemplateTreeItem
  }
}
    ${TemplateDetailsForTemplateTreeItemFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetTemplateDetailsForTemplateTreeItemGQL extends Apollo.Query<GetTemplateDetailsForTemplateTreeItemQuery, GetTemplateDetailsForTemplateTreeItemQueryVariables> {
    override document = GetTemplateDetailsForTemplateTreeItemDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetMaterialDetailsForTemplateTreeItemDocument = gql`
    query getMaterialDetailsForTemplateTreeItem($legacyId: Int!) {
  material(legacyId: $legacyId) {
    ...MaterialDetailsForTemplateTreeItem
  }
}
    ${MaterialDetailsForTemplateTreeItemFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetMaterialDetailsForTemplateTreeItemGQL extends Apollo.Query<GetMaterialDetailsForTemplateTreeItemQuery, GetMaterialDetailsForTemplateTreeItemQueryVariables> {
    override document = GetMaterialDetailsForTemplateTreeItemDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateTemplateRevisionForTemplateTreeItemDocument = gql`
    mutation createTemplateRevisionForTemplateTreeItem($input: MutationCreateTemplateRevisionInput!) {
  createTemplateRevision(input: $input) {
    id
    legacyId
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateTemplateRevisionForTemplateTreeItemGQL extends Apollo.Mutation<CreateTemplateRevisionForTemplateTreeItemMutation, CreateTemplateRevisionForTemplateTreeItemMutationVariables> {
    override document = CreateTemplateRevisionForTemplateTreeItemDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }